<!--begin::Card-->
<div class="card">
    <!--begin::Card header-->
    <div class="card-header border-0 pt-6">
        <!--begin::Card title-->
        <div class="card-title">
            <!--begin::Search-->
            <div class="d-flex align-items-center position-relative my-1">
                <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                </i>
                <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
                    class="form-control form-control-solid w-250px ps-13" placeholder="Search shipping schedules..." />
            </div>
            <!--end::Search-->
        </div>
        <!--end::Card title-->

        <!--begin::Card toolbar-->
        <div class="card-toolbar">
            <!--begin::Toolbar-->
            <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
                <!--begin::Filter-->
                <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="toggleFilters()">
                    <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                    Search
                </button>
                <!--end::Filter-->

                <!--begin::Add shipping schedule-->
                <button type="button" class="btn btn-sm btn-primary fw-bold d-flex" (click)="navigateToAdd()">
                    <i class="ki-duotone ki-plus fs-2"></i>
                    Add Shipping Schedule
                </button>
                <!--end::Add shipping schedule-->
            </div>
            <!--end::Toolbar-->
        </div>
        <!--end::Card toolbar-->
    </div>
    <!--end::Card header-->

    <!--begin::Filters-->
    <div class="card-body border-top pt-6" *ngIf="showFiltersForm">
        <div class="row mb-6">
            <div class="col-md-4">
                <label class="form-label">Search</label>
                <input type="text" class="form-control form-control-solid" [(ngModel)]="filters.search"
                    placeholder="Search...">
            </div>
            <div class="col-md-3">
                <label class="form-label">Date From</label>
                <input type="date" class="form-control form-control-solid" [(ngModel)]="filters.date_from">
            </div>
            <div class="col-md-3">
                <label class="form-label">Date To</label>
                <input type="date" class="form-control form-control-solid" [(ngModel)]="filters.date_to">
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <button type="button" class="btn btn-primary me-2" (click)="onApplyFilters()">Apply</button>
                <button type="button" class="btn btn-light" (click)="onResetFilters()">Reset</button>
            </div>
        </div>
    </div>
    <!--end::Filters-->

    <!--begin::Region Filters-->
    <div class="card-body border-top pt-6 pb-0" *ngIf="!isLoadingRegions && regions.length > 0">
        <div class="d-flex justify-content-center align-items-center flex-wrap gap-3 mb-6">
            <button
                type="button"
                *ngFor="let region of regions"
                class="btn btn-sm"
                [class.btn-primary]="selectedRegion === region.slug"
                [class.btn-light-primary]="selectedRegion !== region.slug"
                (click)="onRegionClick(region.slug)">
                {{ region.name }}
            </button>
        </div>
    </div>
    <!--end::Region Filters-->

    <!-- Card Body -->
    <div class="card-body py-4">
        <!-- Loading indicator for ports -->
        <div *ngIf="isLoadingPorts" class="text-center py-10">
            <span class="spinner-border spinner-border-lg text-primary"></span>
            <div class="mt-3">Loading port data...</div>
        </div>

        <!-- Shipping Schedules Table -->
        <div class="table-responsive" *ngIf="!isLoadingPorts">
            <div class="d-flex">
                <!-- Fixed Columns Section -->
                <div class="flex-shrink-0">
                    <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 mb-0">
                        <thead>
                            <tr class="fw-bold text-muted bg-light">
                                <!-- Shipping Information Heading -->
                                <th class="min-w-500px text-center border-end" [attr.colspan]="5">
                                    Shipping Information
                                </th>
                            </tr>
                            <!-- Sub-header for shipping info columns -->
                            <tr class="fw-bold text-muted bg-light-secondary">
                                <th class="min-w-100px">Action</th>
                                <th class="min-w-150px">Shipping Company</th>
                                <th class="min-w-120px">Vessel</th>
                                <th class="min-w-100px">Voyage</th>
                                <th class="min-w-80px border-end">Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Loading State -->
                            <tr *ngIf="isLoading">
                                <td colspan="5" class="text-center py-5">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="spinner-border spinner-border-sm me-2"></span>
                                        Loading shipping schedules...
                                    </div>
                                </td>
                            </tr>

                            <!-- No Data State -->
                            <tr *ngIf="!isLoading && shippingSchedules.length === 0">
                                <td colspan="5" class="text-center py-5">
                                    <div class="text-muted">No shipping schedules found</div>
                                </td>
                            </tr>

                            <!-- Data Rows - Fixed Columns -->
                            <tr *ngFor="let schedule of shippingSchedules; trackBy: trackByFn">
                                <!-- Action -->
                                <td class="">
                                    <div class="justify-content-end gap-2">
                                        <!-- Edit Icon -->
                                        <button type="button" class="btn btn-sm btn-icon btn-light-primary"
                                            (click)="onEdit(schedule)" title="Edit Transport Pickup">
                                            <i class="ki-duotone ki-pencil fs-5">
                                                <span class="path1"></span>
                                                <span class="path2"></span>
                                            </i>
                                        </button>

                                        <!-- Delete Icon -->

                                    </div>
                                </td>


                                <!-- Shipping Company -->
                                <td>
                                    <span class="text-dark fw-semibold d-block fs-7">
                                        {{ schedule.shipping_company_name || '-' }}
                                    </span>
                                </td>

                                <!-- Vessel -->
                                <td>
                                    <span class="text-dark fw-semibold d-block fs-7">
                                        {{ schedule.vessel || '-' }}
                                    </span>
                                </td>

                                <!-- Voyage -->
                                <td>
                                    <span class="text-dark fw-semibold d-block fs-7">
                                        {{ schedule.voyage_no || '-' }}
                                    </span>
                                </td>

                                <!-- Type -->
                                <td class="border-end">
                                    <span class="badge" [class.badge-light-success]="schedule.type === 'roro'"
                                        [class.badge-light-primary]="schedule.type === 'container'">
                                        {{ schedule.type | titlecase }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Scrollable Port Columns Section -->
                <div class="flex-grow-1 overflow-auto" style="max-width: calc(100vw - 600px);">
                    <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 mb-0">
                        <thead>
                            <tr class="fw-bold text-muted bg-light">
                                <!-- From Port Columns -->
                                <th class="min-w-200px text-center border-end" [attr.colspan]="portFromList.length"
                                    *ngIf="portFromList.length > 0">
                                    From Port
                                </th>

                                <!-- Destination Port Columns -->
                                <th class="min-w-200px text-center" [attr.colspan]="destinationPortList.length"
                                    *ngIf="destinationPortList.length > 0">
                                    Destination Port
                                </th>
                            </tr>

                            <!-- Sub-header for port names -->
                            <tr class="fw-bold text-muted bg-light-secondary">
                                <!-- From Port Names -->
                                <th class="min-w-100px text-center" *ngFor="let port of portFromList; let isLast = last"
                                    [class.border-end]="isLast">
                                    {{ port.name }}
                                </th>

                                <!-- Destination Port Names -->
                                <th class="min-w-100px text-center" *ngFor="let port of destinationPortList">
                                    {{ port.name }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Loading State -->
                            <tr *ngIf="isLoading">
                                <td [attr.colspan]="portFromList.length + destinationPortList.length"
                                    class="text-center py-5">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="spinner-border spinner-border-sm me-2"></span>
                                        Loading port data...
                                    </div>
                                </td>
                            </tr>

                            <!-- No Data State -->
                            <tr *ngIf="!isLoading && shippingSchedules.length === 0">
                                <td [attr.colspan]="portFromList.length + destinationPortList.length"
                                    class="text-center py-5">
                                    <div class="text-muted">No port data available</div>
                                </td>
                            </tr>

                            <!-- Data Rows - Port Columns -->
                            <tr *ngFor="let schedule of shippingSchedules; trackBy: trackByFn">
                                <!-- From Port Values -->
                                <td class="text-center" *ngFor="let port of portFromList; let isLast = last"
                                    [class.border-end]="isLast">
                                    <span class="text-dark fw-semibold d-block fs-7">
                                        {{ getPortValue(schedule, port._id || port.id, 'from') }}
                                    </span>
                                </td>

                                <!-- Destination Port Values -->
                                <td class="text-center" *ngFor="let port of destinationPortList">
                                    <span class="text-dark fw-semibold d-block fs-7">
                                        {{ getPortValue(schedule, port._id || port.id, 'destination') }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Pagination -->
        <app-pagination [paginationInfo]="paginationInfo" [loading]="isLoading" (pageChange)="onPageChange($event)"
            *ngIf="!isLoading && paginationInfo.total > 0">
        </app-pagination>
    </div>
    <!--end::Card body-->
</div>
<!--end::Card-->
